var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TheBreadcrumb"},_vm._l((_vm.routeParts),function(part,index){return (part.name)?_c('router-link',{key:index,attrs:{"to":part.path}},[_vm._v(_vm._s(part.name))]):_vm._e()}),1)}
var staticRenderFns = []

export { render, staticRenderFns }